import { Stack } from '@mui/material'
import { useSearchParams } from 'react-router-dom'

import { FigmaIntegration } from './figma-integration'
import { GitHubIntegrations } from './github-integrations'
import { GitLabIntegrations } from './gitlab-integrations'

export const ProjectIntegrationsTabContent = ({
  projectId,
}: {
  projectId: string
}) => {
  const [searchParams, setSearchParams] = useSearchParams()

  const authCode = searchParams.get('authCode')

  const removeAuthCode = () => {
    searchParams.delete('authCode')
    setSearchParams(searchParams)
  }

  return (
    <Stack spacing={3} width={1} mx="auto">
      <GitHubIntegrations projectId={projectId} />

      <FigmaIntegration
        projectId={projectId}
        authCode={authCode}
        removeAuthCode={removeAuthCode}
      />

      <GitLabIntegrations projectId={projectId} />
    </Stack>
  )
}
